import React from 'react';
export var RceConfigKeys = {
  canvasUserId: 'canvasUserId',
  canvasToolId: 'canvasToolId',
  editorButtons: 'editorButtons',
  contextId: 'contextId',
  contextType: 'contextType',
  resourceId: 'resourceId',
  resourceType: 'resourceType',
  rcsHost: 'rcsHost',
  rcsJwt: 'rcsJwt',
  rcsJwtRefreshFn: 'rcsJwtRefreshFn',
  handleError: 'handleError',
  canvasOrigin: 'canvasOrigin',
  canvasConfig: 'canvasConfig',
  ltiIframeAllowances: 'ltiIframeAllowances',
  displayOldLinks: 'displayOldLinks'
};
export var RceConfigContext = React.createContext(null);